import { AngleMeasurementDetails } from './AngleMeasurementDetails';
import { createAngleMeasurementController } from './angle-measurement-controller';

export const angleMeasurementConfig = {
  detailsComponent: AngleMeasurementDetails,
  optionsComponent: undefined,
  createController: createAngleMeasurementController,
};

export type {
  AngleDetailsProps,
  AngleMeasurementController,
} from './angle-measurement.types';
export type { AngleMeasurementDetailsProps } from './AngleMeasurementDetails';
export { AngleMeasurementDetails, createAngleMeasurementController };
